module.exports = __webpack_public_path__ + "img/50m3.9c73b0b0.jpg";